export default "__VITE_ASSET__D6sAq3WI__"